import React from 'react';
import { Scale, Shield, FileText, AlertCircle, BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Separator } from '../components/ui/separator';
import Layout from '../components/layout/Layout';
import { legalContent } from '../data/mock';

const LegalPage = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-b from-gray-50 to-white py-16 lg:py-24 overflow-hidden">
        <div className="absolute inset-0 medical-pattern opacity-50" />
        <div className="decorative-circle w-96 h-96 -top-48 -right-48 opacity-30" />
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 rounded-full text-teal-700 text-sm font-medium mb-6">
              <BookOpen className="w-4 h-4" />
              <span>Informations légales</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-light text-gray-900">
              Mentions légales et éthique
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
              Informations légales, engagement déontologique et protection de vos données personnelles.
            </p>
          </div>
        </div>
      </section>

      {/* Legal Content */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto space-y-8">
            {/* Legal Mentions */}
            <Card className="border-0 shadow-lg overflow-hidden">
              <div className="h-1 bg-gradient-to-r from-gray-300 to-gray-400" />
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-gray-900">
                  <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center">
                    <FileText className="w-5 h-5 text-gray-600" />
                  </div>
                  {legalContent.mentions.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-3">
                  {legalContent.mentions.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-3 text-gray-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            <Separator />

            {/* Ethics */}
            <div id="ethique">
              <Card className="border-0 shadow-lg overflow-hidden">
                <div className="h-1 bg-gradient-to-r from-teal-400 to-teal-600" />
                <CardHeader>
                  <CardTitle className="flex items-center gap-3 text-gray-900">
                    <div className="w-10 h-10 rounded-xl bg-teal-100 flex items-center justify-center">
                      <Scale className="w-5 h-5 text-teal-700" />
                    </div>
                    {legalContent.ethics.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {legalContent.ethics.text}
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Privacy */}
            <div id="donnees">
              <Card className="border-0 shadow-lg overflow-hidden">
                <div className="h-1 bg-gradient-to-r from-blue-400 to-blue-600" />
                <CardHeader>
                  <CardTitle className="flex items-center gap-3 text-gray-900">
                    <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
                      <Shield className="w-5 h-5 text-blue-700" />
                    </div>
                    {legalContent.privacy.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600 leading-relaxed">
                    {legalContent.privacy.text}
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Disclaimer */}
            <Card className="border-0 shadow-lg bg-gradient-to-br from-amber-50 to-amber-100 overflow-hidden">
              <div className="h-1 bg-gradient-to-r from-amber-400 to-amber-500" />
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-amber-800">
                  <div className="w-10 h-10 rounded-xl bg-amber-200 flex items-center justify-center">
                    <AlertCircle className="w-5 h-5 text-amber-700" />
                  </div>
                  {legalContent.disclaimer.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-amber-900 leading-relaxed">
                  {legalContent.disclaimer.text}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default LegalPage;
